interface OptionsProps {
    map: google.maps.Map;
    size: google.maps.Size;
    rotation: number;
    icon: string;
    latlng: google.maps.LatLng;
}

export const createCarMarker = (options: OptionsProps) => {
    class GoogleMarker extends google.maps.OverlayView {
        options: OptionsProps = {} as OptionsProps;
        div: HTMLDivElement | null = null;

        constructor(options: OptionsProps) {
            super();
            this.options = options;
            this.setMap(options.map);
        }

        createDiv() {
            const size = this.getSize(this.options.size);
            this.div = document.createElement("div");
            this.div.style.position = "absolute";
            this.div.style.transition = "2s ease-in-out";
            this.setRotation(this.options.rotation);
            this.div.innerHTML = `<img style="height:${size.height}px;width:${size.height}px" id="car" src="${this.options.icon}">`;
        }

        appendDivToOverlay(appendDiv: HTMLDivElement) {
            const panes = this.getPanes();
            if (panes && panes.floatPane) {
                panes.floatPane.appendChild(appendDiv);
            }
        }

        setRotation(degrees: number) {
            if (this.div) {
                const currentAngle = this.options.rotation;
                const rightRotation = degrees - currentAngle;
                const leftRotation = degrees - currentAngle - 360;
                const shorterRotation =
                    Math.abs(rightRotation) < Math.abs(leftRotation) ? rightRotation : leftRotation;
                const newRotation = currentAngle + shorterRotation;

                this.options.rotation = newRotation;
                this.div.style.transform = `rotate(${newRotation}deg)`;
            }
        }

        private positionDiv(div: HTMLDivElement | null, options: OptionsProps) {
            if (div != null) {
                const point = this.getProjection().fromLatLngToDivPixel(options.latlng);
                if (point) {
                    const size = this.getSize(options.size);
                    const anchor = new google.maps.Point(size.width / 2, size.height / 2);
                    div.style.left = `${point.x - anchor.x}px`;
                    div.style.top = `${point.y - anchor.y}px`;
                }
            }
        }

        private getSize(size: google.maps.Size) {
            return (
                size || {
                    height: 52,
                    width: 52,
                }
            );
        }

        draw() {
            if (!this.div) {
                this.createDiv();
                if (this.div) {
                    this.appendDivToOverlay(this.div);
                }
            }
            this.positionDiv(this.div, this.options);
        }

        setPosition(position: google.maps.LatLng) {
            this.options.latlng = position;
            this.positionDiv(this.div, this.options);
        }

        onRemove() {
            if (this.div && this.div.parentNode) {
                this.div.parentNode.removeChild(this.div);
                this.div = null;
            }
        }
    }
    return new GoogleMarker(options);
};
